/* global location */
import React, { useEffect } from 'react';
import GBIButton from '../util/buttons/components/GBIButton';
import { getDashboardDomain } from '../util/site';
import './redirect-to-admin.scss';

const RedirectToAdmin = () => {
  const domain = getDashboardDomain();
  const url = `${domain}${location.pathname}${location.search}`;
  useEffect(() => {
    window.location = url;
  }, []);
  return (
    <div className="redirect-to-admin">
      <p>The GoodBeef Index Admin has moved. Click here to be redirected...</p>
      <a href={ url }>
        <GBIButton label="Login to the new admin"></GBIButton>
      </a>
    </div>
  );
};

export default RedirectToAdmin;
